import { render } from "./ChatPage.vue?vue&type=template&id=50d855ac&scoped=true&ts=true"
import script from "./ChatPage.vue?vue&type=script&lang=ts"
export * from "./ChatPage.vue?vue&type=script&lang=ts"

import "./ChatPage.vue?vue&type=style&index=0&id=50d855ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d855ac"]])

export default __exports__